import { Chip, ChipProps } from "@mui/material";
import React from "react";

export const RolloutChip: React.FC<
  { variant: "6.5+" | "-6.5" } & Omit<ChipProps, "variant">
> = ({ variant, ...baseProps }) => {
  let label: string;

  switch (variant) {
    case "6.5+": {
      label = "6.5+";
      break;
    }
    case "-6.5": {
      label = "5.0-6.4";
      break;
    }
  }

  return (
    <Chip
      className="ml-2 uppercase"
      size="small"
      label={label}
      {...baseProps}
    />
  );
};
